<template>
	<div class="inspectionAccount">
		<!-- 过滤项 -->
		<filter-panel :data="groups" @search="filterChange"></filter-panel>

		<div class="addBut">
			<el-button type="primary" @click="add">新增</el-button>
		</div>

		<!-- 列表 -->
		<data-list
			:data="data"
			:columns="column"
			:page="page"
			:table-style="{ name: 'mixture' }"
			:page-size="page.pageSize"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@expand-change="expandChange"
		></data-list>

		<!-- 表单弹窗 -->
		<dialog-form
			:dialogVisible="dialogVisible"
			:attributes="attributes"
			:formData="formData"
			@close:dialogVisible="val => (dialogVisible = val)"
			@confirm="confirm"
		></dialog-form>

		<!-- 操作验证 -->
		<verificationCode ref="verificationCode"></verificationCode>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import dialogForm from '@/components/dialogForm/dialogForm';
import verificationCode from './verificationCode.vue';
import inspectionAccountExpand from './inspectionAccountExpand.vue';

import api from '@/backend/apiConfig/apiConfig';
import dict from '@/backend/services/dictionary/dictionary';
import inspectionSer from '@/backend/services/inspection/inspection.js';
import listPageCreate from '@/mixins/listPageCreate';
import { validRequired, validMobile } from '@/common/elementValid.js';

const list = listPageCreate({
	searchConfig: {
		api: api.inspection.getInspectionList,
		method: 'POST',
	},
	afterResponse: res => {
		let dataMap = res.data.data.map(item => {
			return {
				...item,
				children: [],
			};
		});

		return {
			data: {
				...res.data,
				data: dataMap,
			},
		};
	},
});

export default {
	name: 'inspectionAccount',
	components: {
		filterPanel,
		dialogForm,
		verificationCode,
	},
	mixins: [list],
	data() {
		return {
			// 表单数据
			dialogVisible: false,
			editId: '',
			attributes: {
				width: '40%',
				title: '新增',
			},

			// 列表和过滤项属性
			groups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '巡检账号/巡检人',
						label: '巡检账号/巡检人',
						prop: 'nameOrMobile',
						value: '',
					},
					{
						tagName: 'sky-input',
						placeholder: '巡检客户',
						label: '巡检客户',
						prop: 'customerName',
						value: '',
					},
				],
			},
			column: [],
			formData: {
				name: {
					formType: 'sky-input',
					value: '',
					placeholder: '巡检人',
					label: '巡检人',
					rules: [validRequired('请输入巡检人', 'blur')],
				},
				mobile: {
					formType: 'sky-input',
					value: '',
					placeholder: '巡检账号',
					label: '巡检账号',
					rules: [validRequired('请输入巡检账号', 'blur'), validMobile()],
				},
			},
		};
	},
	mounted() {
		this.setColumn();
	},
	methods: {
		// 设置列表项
		async setColumn() {
			let self = this;
			let options = await this.getCustomerOptions();
			this.column = [
				{
					label: '',
					type: 'tableExpand',
					width: 60,
					tagName: inspectionAccountExpand,
				},
				{
					label: '巡检账号',
					formartAmout: false,
					bind: ({ mobile }) => {
						return mobile || '';
					},
				},
				{
					label: '巡检人',
					formartAmout: false,
					bind: ({ name }) => {
						return name || '';
					},
				},
				{
					label: '巡检客户',
					type: 'selectChange',
					bind: 'customerId',
					options,
					props: {
						value: 'id',
						label: 'value',
					},
					change(customerId, row) {
						self.editInspectionCustomer(customerId, row);
					},
				},
				{
					label: '巡检添加时间',
					bind: 'createTime',
				},
				{
					label: '添加人',
					formartAmout: false,
					bind: ({ createrName }) => {
						return createrName || '';
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					style: 'text',
					width: 200,
					bind: () => {
						return [
							{
								text: '更改账号',
								trigger: row => {
									let { id, mobile, name } = row;
									self.attributes['title'] = '更改';
									self.editId = id;
									self.formData['mobile'].value = mobile;
									self.formData['name'].value = name;
									self.dialogVisible = true;
								},
							},
							{
								text: '删除',
								trigger: ({ id }) => {
									self.delInspection(id);
								},
							},
						];
					},
				},
			];
			this.query();
		},
		// 唤起新增弹窗
		add() {
			this.attributes['title'] = '新增';
			this.editId = '';
			this.formData['mobile'].value = '';
			this.formData['name'].value = '';
			this.dialogVisible = true;
		},
		// 展开行
		expandChange({ row, arr }) {
			let { id } = row;
			let obj = arr.find(item => {
				return item.id === id;
			});

			if (obj) this.getInspectionHistoryList(id);
		},
		// 表单提交
		async confirm(cb) {
			let { editId, formData } = this;

			let { cancel, userId, code } = await this.$refs.verificationCode.show();
			if (!cancel) {
				let params = {};
				_.forEach(formData, (val, key) => {
					params[key] = val.value;
				});
				if (!editId) {
					this.addInspection(
						{
							...params,
							userId,
							code,
						},
						cb
					);
				} else {
					this.editInspection(
						{
							...params,
							userId,
							code,
						},
						cb
					);
				}
			} else {
				cb(false);
			}
		},
		// 新增巡检账号
		async addInspection(params, cd) {
			try {
				let res = await inspectionSer.addInspection(params);
				if (res.data) {
					cd(true);
					this.$message.success('新增成功');
					this.query();
				}
			} catch (error) {
				console.log(error);
				cd(false);
				this.$message.error('新增失败');
			}
		},
		// 新增巡检账号
		async editInspection(params, cd) {
			try {
				let { editId: id } = this;
				await inspectionSer.editInspection({
					params,
					id,
				});
				cd(true);
				this.$message.success('更改成功');
				this.query();
			} catch (error) {
				console.log(error);
				cd(false);
				this.$message.error('更改失败');
			}
		},
		// 删除巡检账号
		async delInspection(id) {
			try {
				let control = await this.$confirmShow('确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				});
				if (control) {
					await inspectionSer.delInspection({
						id,
					});
					this.$message.success('删除成功');
					this.query();
				}
			} catch (error) {
				this.$message.error('删除失败');
			}
		},
		// 修改巡检客户
		async editInspectionCustomer(customerId, row) {
			let { id } = row;
			await inspectionSer.editInspectionCustomer({
				customerId,
				id,
			});
			this.query();
		},
		// 历史记录列表
		async getInspectionHistoryList(id) {
			let res = await inspectionSer.getInspectionHistoryList({ accountId: id });
			if (res.data) {
				let index = this.data.findIndex(item => {
					return item.id === id;
				});
				this.data[index].children = res.data;
			}
		},
		// 获取客户列表
		async getCustomerOptions() {
			const res = await dict.getCustomerName();
			return res.data;
		},
	},
};
</script>

<style lang="scss" scoped>
.inspectionAccount {
	.addBut {
		width: 100%;
		height: 60px;
		margin: 10px 0;
		padding: 0 20px;
		background-color: #fff;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
}
</style>
